import React, {FC} from 'react';
import routes from '../../../config/routes';

// Styles
import Container from '../../../components/Layout/Container';
import H1 from '../../../components/Headings/H1';
import {Links} from '../../../components/LinksStyle/index';
import {ErrorPage, ErrorPageInner} from '../../../components/Error/error.style';
import { Helmet } from 'react-helmet-async';


// Messages
import { FormattedMessage } from 'react-intl';
import generalMessages from '../../generalMessages';

const Error404: FC = () => {

  return (
    <ErrorPage>
      <Helmet>
        <title>Ova vest je istekla</title>
        <meta name="render:status_code" content="404" />
      </Helmet>
      <Container>
        <ErrorPageInner>
          <H1><FormattedMessage {...generalMessages.News404}/></H1>
          <Links to={routes.HomePage}><FormattedMessage {...generalMessages.HomePage}/></Links>

        </ErrorPageInner>
      </Container>
    </ErrorPage>
  )
}

export default Error404;
